import type { AuthRepositoryPort } from "../ports/auth.repository.port";

export function verifyEmailUseCase(repository: AuthRepositoryPort, token: string) {
  return repository.verifyEmail(token);
}
